import { render, staticRenderFns } from "./EntConfig.vue?vue&type=template&id=87797b66&"
import script from "./EntConfig.vue?vue&type=script&lang=js&"
export * from "./EntConfig.vue?vue&type=script&lang=js&"
import style0 from "./EntConfig.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports